import { UseFormReturn } from 'react-hook-form';
import { MapFormValues } from './useMapForm';
import { HoverLabelToggle } from './HoverLabelToggle';

interface DroneHoverLabelsProps {
  form: UseFormReturn<MapFormValues>;
}

const DRONE_HOVER_FIELDS = [
  { name: 'drone_uasId', label: 'UAS ID', description: 'Show UAS ID when hovering drone' },
  { name: 'drone_macAddress', label: 'MAC Address', description: 'Show MAC address when hovering drone' },
  { name: 'drone_uaType', label: 'UA Type', description: 'Show UA type when hovering drone' },
  { name: 'drone_altitude', label: 'Altitude', description: 'Show altitude when hovering drone' },
  { name: 'drone_speed', label: 'Speed', description: 'Show speed when hovering drone' },
  { name: 'drone_heading', label: 'Heading', description: 'Show heading when hovering drone' },
  { name: 'drone_latitude', label: 'Latitude', description: 'Show latitude when hovering drone' },
  { name: 'drone_longitude', label: 'Longitude', description: 'Show longitude when hovering drone' },
  { name: 'drone_operatorLatitude', label: 'Operator Latitude', description: 'Show operator latitude when hovering drone' },
  { name: 'drone_operatorLongitude', label: 'Operator Longitude', description: 'Show operator longitude when hovering drone' },
  { name: 'drone_lastReportTimestamp', label: 'Last Report', description: 'Show last report timestamp when hovering drone' },
  { name: 'drone_operationStatus', label: 'Operation Status', description: 'Show operation status when hovering drone' },
] as const;

export const DroneHoverLabels = ({ form }: DroneHoverLabelsProps) => {
  return (
    <div className="grid grid-cols-2 gap-4">
      {DRONE_HOVER_FIELDS.map((field) => (
        <HoverLabelToggle
          key={field.name}
          form={form}
          name={field.name}
          label={field.label}
          description={field.description}
        />
      ))}
    </div>
  );
};
